import { render, staticRenderFns } from "./ModalPerfis.vue?vue&type=template&id=27043994&"
import script from "./ModalPerfis.vue?vue&type=script&lang=js&"
export * from "./ModalPerfis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports